.fairs-page {
  display: flex;
  width: 100%;
  height: calc(100vh - var(--navbar-height));
  overflow: hidden;
}

.fairs-sidebar {
  display: flex;
  flex: 0 0 280px;
  flex-direction: column;
  padding: 1.25rem 1rem;
  overflow-y: auto;
  border-right: 1px solid #e5e7eb;
}

.fairs-content {
  flex: 1;
  min-width: 0;
  padding: 1.5rem 2rem 2rem;
  overflow: auto;
}

.header-row {
  margin-bottom: 1rem;
}

.fairs-overview {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.fairs-overview ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.fairs-overview li {
  margin-bottom: 0.4rem;
}

.fair-button {
  width: 100%;
  padding: 0.45rem 0.65rem;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  text-align: left;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--umati-text);
}

.fair-button:hover {
  background-color: #f1f5f9;
}

.fair-button[aria-current='true'] {
  border-color: var(--umati-blue);
  background-color: #e6f6fd;
  color: var(--umati-blue);
}

.name-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.name-subheading {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 1.25rem;
  font-size: 0.85rem;
  color: var(--umati-muted);
}

.images-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}

.image-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  align-items: flex-start;
}

.image-label {
  font-size: 0.75rem;
  color: var(--umati-muted);
}

.fair-image,
.image-placeholder {
  width: 200px;
  height: 130px;
  object-fit: contain;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fafafa;
}

.image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: #9ca3af;
  border-style: dashed;
}

.hidden-badge {
  margin-left: 0.5rem;
  padding: 0.05rem 0.4rem;
  font-size: 0.7rem;
  color: var(--umati-muted);
  border: 1px solid #d1d5db;
  border-radius: 999px;
}

.hall-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.2rem 0.3rem 0.2rem 0.6rem;
  font-size: 0.85rem;
  color: var(--umati-text);
  background: #f1f5f9;
  border: 1px solid #dbe1e6;
  border-radius: 999px;
}

.hall-remove {
  display: inline-flex;
  align-items: center;
  padding: 0;
  color: var(--umati-muted);
  background: none;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}

.hall-remove:hover {
  color: #dc3545;
}

.table thead th {
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--umati-text);
}

.table tbody td,
.table tbody th {
  font-size: 0.85rem;
  vertical-align: middle;
}
